import { useEffect } from "react";
const ONE_MINUTE = 600000;
const SESSION_CHECK_INTERVAL = 30 * 60 * 10000;

const useAutoLogout = (props) => {
    if (!props && !props.history) return;
    useEffect(() => {
        let timeout;
        const resetTimer = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                localStorage.removeItem("cookie");
                window.onbeforeunload = null;
                alert(
                    "Tu sesión ha expirado debido a inactividad. Por favor, inicia sesión nuevamente."
                  );
                props.history.push("/login");
   
            }, SESSION_CHECK_INTERVAL);
        };

        window.addEventListener("click", resetTimer);
        window.addEventListener("scroll", resetTimer);
        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);

        resetTimer();

        return () => {
            clearTimeout(timeout);
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("click", resetTimer);
            window.removeEventListener("scroll", resetTimer);
        };
    }, [props.history]);

    return null;
};

export default useAutoLogout;
